import { FC } from 'react';
import { css } from '@emotion/core';
import { Flex } from '@rebass/emotion';
import { useFormContext } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import styled from '@emotion/styled';
import Card from '@app/components/Card';
import { H4 } from '@app/shop/components/typography';
import { rem } from '@app/styles/theme/layout';
import messages from '../Address.messages';
import { AddressFormFields } from '../Address.constants';

const AddAddressButton: FC = () => {
  const { errors, setValue, getValues } = useFormContext();
  const isAddressFormVisible = getValues(AddressFormFields.FormVisible);

  return (
    <Card
      data-testid="add-address-button"
      as="button"
      hasError={!!errors[AddressFormFields.Selected]}
      css={css`
        cursor: pointer;
        width: 100%;
        height: 100%;
        padding-top: ${rem(10)};
        padding-bottom: ${rem(10)};
      `}
      onClick={() => {
        setValue(AddressFormFields.FormVisible, !isAddressFormVisible);
      }}
    >
      <Flex alignItems="center" justifyContent="center">
        <ExpandSign isExpanded={isAddressFormVisible} />
        <H4
          css={css`
            display: inline-block;
            margin: 0 0 0 ${rem(10)};
          `}
        >
          <FormattedMessage {...messages.addAddressButtonLabel} />
        </H4>
      </Flex>
    </Card>
  );
};

export default AddAddressButton;

const ExpandSign = styled.span<{ isExpanded: boolean }>`
  &::before {
    content: ${(props) => (props.isExpanded ? '"-"' : '"+"')};
    display: block;
    width: 2rem;
    height: 2rem;
    border: 2px solid #000;
    border-radius: 50%;
    font-size: 1.25rem;
    font-weight: 600;
  }
`;
